import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { ReduxState, ThunkDispatchType } from 'app/redux/types';

import { Button, ButtonSize } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';

import {
  CloseBigStakeBar, closeBigStakeBar,
  HideBigStakeInfo, ShowBigStakeInfo,
  // hideBigStakeInfo, showBigStakeInfo,
} from '../../actions/bigStakes';
import {
  selectBigStakes,
  selectFailedBigStakes,
  selectStakesWithDecisionSize,
  selectVisibleBigStakeInfo,
} from '../../selectors/bigStakes';
import { selectWaitingInQueue } from '../../selectors/waitingInQueue';
import Entries from './Entries';
import Header from './Header';

import dictionary from './BigStakesBar.dictionary.json';

import styles from './BigStakesBar.module.scss';


// ---
//Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
// const SHOW_BIG_STAKE_TIMEOUT = 500; // look README.md
// const HIDE_BIG_STAKE_TIMEOUT = 2000;

type StoreProps = {
  hasQueueStake: boolean;
  bigStakesSize: number;
  failedBigStakesSize: number;
  stakesWithDecisionSize: number;
  visibleBigStakeInfo: boolean;
};

type DispatchProp = {
  dispatch: ThunkDispatchType<ShowBigStakeInfo | HideBigStakeInfo | CloseBigStakeBar>;
};

const BigStakesBar: FC<DispatchProp & StoreProps> = ({
  // hasQueueStake,
  bigStakesSize,
  failedBigStakesSize,
  stakesWithDecisionSize,
  // visibleBigStakeInfo,
  dispatch,
}) => {
  const { t } = useTranslation();
  //Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
  // const showBigStakeTimeoutId = useRef<NodeJS.Timer | null>(null);
  // const hideBigStakeTimeoutId = useRef<NodeJS.Timer | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const stakesComplete = (bigStakesSize - stakesWithDecisionSize) === 0;
  //Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
  // useEffect(() => () => {
  //   showBigStakeTimeoutId.current && clearInterval(showBigStakeTimeoutId.current);
  //   hideBigStakeTimeoutId.current && clearInterval(hideBigStakeTimeoutId.current);
  //   dispatch(hideBigStakeInfo());
  // }, []);
  //
  // useEffect(() => {
  //   if (hasQueueStake) {
  //     if (!showBigStakeTimeoutId.current) {
  //       showBigStakeTimeoutId.current = setTimeout(() => {
  //         dispatch(showBigStakeInfo());
  //       }, SHOW_BIG_STAKE_TIMEOUT);
  //     }
  //   }
  //   else if (showBigStakeTimeoutId.current) {
  //     clearTimeout(showBigStakeTimeoutId.current);
  //     showBigStakeTimeoutId.current = null;
  //   }
  // }, [showBigStakeTimeoutId.current, hasQueueStake]);
  //
  // useEffect(() => {
  //   if (visibleBigStakeInfo && !hasQueueStake) {
  //     if (!hideBigStakeTimeoutId.current) {
  //       hideBigStakeTimeoutId.current = setTimeout(() => {
  //         dispatch(hideBigStakeInfo());
  //       }, HIDE_BIG_STAKE_TIMEOUT);
  //     }
  //   }
  //   else if (hideBigStakeTimeoutId.current) {
  //     clearTimeout(hideBigStakeTimeoutId.current);
  //     hideBigStakeTimeoutId.current = null;
  //   }
  // }, [hideBigStakeTimeoutId.current, hasQueueStake, visibleBigStakeInfo]);

  useEffect(() => {
    if (isOpen && stakesComplete && failedBigStakesSize === 0) {
      setIsOpen(false);
    }
  }, [isOpen, stakesComplete, failedBigStakesSize]);

  const toggleBigStakesDisplayHandler = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  const closeBigStakeBarHandler = useCallback(() => {
    dispatch(closeBigStakeBar());
    setIsOpen(false);
  }, []);

  if (bigStakesSize <= 0) {
    return null;
  }

  return (
    <div className={classNames(styles.container, { [styles.openedContainer]: isOpen })}
         data-test="bigStakesBar-container">
      <Header isOpenBigStakeBar={isOpen}
              onToggleBigStakeBar={toggleBigStakesDisplayHandler}
              onCloseBigStakeBar={closeBigStakeBarHandler} />

      {isOpen && (
        <>
          <Entries />
          {stakesComplete && failedBigStakesSize > 0 && (
            <Button size={ButtonSize.SMALL}
                    className={styles.closeButton}
                    data-test="bigStakesBar-closeWindowButton"
                    onClick={closeBigStakeBarHandler}>
              {t(dictionary.buttonText)}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  hasQueueStake: selectWaitingInQueue(state).size > 0,
  failedBigStakesSize: selectFailedBigStakes(state).length,
  bigStakesSize: selectBigStakes(state).size,
  stakesWithDecisionSize: selectStakesWithDecisionSize(state),
  visibleBigStakeInfo: selectVisibleBigStakeInfo(state),
});

export default connect(mapStateToProps)(BigStakesBar);
